module.exports = __webpack_public_path__ + "media/images/referrals/people-with-disabilities-efacdadfc8e1960bc82f1a75f9d53e08.png";